import { Component, Input, OnInit} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SettingService } from 'src/app/shared/services/setting.service';
import { IOrder } from '../closedsub/closedsub-modal.component';
import { IStore } from '../../services/store.service';
import { IPlacePreOrderBase, IPreOrder, PreOrderService } from '../../services/preorder.service';
//import * as moment from 'moment';
import moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { IPlaceOrder } from '../../services/order.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ProfileService } from 'src/app/account/services/profile.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-table-order-confirmation-modal',
    templateUrl: './table-order-confirmation-modal.component.html',
    styleUrls: ['./table-order-confirmation-modal.component.scss'],
    standalone: false
})
export class TableOrderConfirmationModalComponent implements OnInit {

  @Input() order: IOrder;
  @Input() store: IStore;

  textVisible: boolean = false;
  
  constructor(
    //public translateService: TranslateService,
    private modalCtrl: ModalController,
    private setting: SettingService,
    private preOrderService: PreOrderService,
    private auth: AuthService,
    private loader: LoaderService,
    private profileService: ProfileService,
    private translationService: TranslationService
    ) { }

  ngOnInit() {
    this.profileService.getProfile()
      .subscribe((profile) => {
        let firstName =  profile && profile.FirstName && profile.LastName ? profile.FirstName : "Table";
        let lastName = profile && profile.FirstName && profile.LastName ? profile.LastName : localStorage.getItem('tableNumber');

        this.createPlacePreOrder(firstName, lastName);
      },
      () => {
        let firstName =  "Table";
        let lastName = localStorage.getItem('tableNumber');

        this.createPlacePreOrder(firstName, lastName);
      });
  }
 
  async cancel() {
    await this.modalCtrl.dismiss();
  }

  isLoeufrierLogo() {
    return this.setting.getMerchantId() == '60562f915c4b23000133c87b';
  }

  private async createPlacePreOrder(firstName: string, lastName: string){
    let order: IPreOrder = {
      preOrderItems: this.order.orderItems.filter(i => i.orderType == this.order._deliveryType),
      note: "Table #" + localStorage.getItem('tableNumber')
    };

    let placePreOrder: IPlacePreOrderBase = {
      storeId: this.store.id,
      terminalId: -1,
      preOrder: order,
      customerFirstName: firstName,
      customerLastName: lastName,
      customerName: firstName + " " + lastName,
      customerEmail: null,
      phone: null,
      giftCard: null,
      eCouponCode: null,
      note: null,
      language: this.translationService.getLanguage(),
      employeeId: -1,
      tableAssigned: parseInt(localStorage.getItem('tableNumber')),
      guestCount: -1,
      orderTip: 0,
      timeZone: moment().format("Z"),
      orderDate: moment().add(1, 'day').format("yyyy-MM-DD").toString(),
      orderTime: null,
      _store: this.store,
      _orderDate: new Date()
    };

    this.placePreOrder(placePreOrder);
  }

  private async placePreOrder(placePreOrder: IPlacePreOrderBase){
    const loader = await this.loader.create();
    await loader.present();
    if (this.auth.isAuthenticated){
      this.preOrderService.memberPlaceOrder(placePreOrder)
      .subscribe(async data => {
        this.updateLocalStorage(placePreOrder);
        this.textVisible = true;
        await loader.dismiss();
      });
    } else {
      this.preOrderService.placeOrder(placePreOrder)
      .subscribe(async data => {
        this.updateLocalStorage(placePreOrder);
        this.textVisible = true;
        await loader.dismiss();
      });
    }
  }

  private updateLocalStorage(placePreOrder: IPlacePreOrderBase){
    let preOrders: IPlacePreOrderBase[] = [];
    if(localStorage['tableOrders']){
      preOrders = JSON.parse(localStorage['tableOrders']);
    } 
    preOrders.push(placePreOrder);
    localStorage['tableOrders'] = JSON.stringify(preOrders);

    localStorage.removeItem('tableNumber');
    let remainingCartItems = this.order.orderItems.filter(i => i.orderType != this.order._deliveryType);
    if (remainingCartItems.length > 0) {
      localStorage['cartStorage'] = JSON.stringify(remainingCartItems);
      return;
    }
    localStorage.removeItem('cartStorage');
    localStorage.removeItem('StoreId');
    localStorage.removeItem('TimeLimit')
  }
}
